import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
import { useLang } from '@/context/LanguageContext';

const LocationSection = () => {
  const { t } = useLang();

  return (
    <section data-testid="location-section" className="py-24 md:py-32 bg-[#3D2020]">
      <div className="px-5 md:px-10 lg:px-14 max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-[11px] uppercase tracking-[0.3em] text-white/50 mb-4 font-medium">{t('location.label')}</p>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight mb-6 whitespace-pre-line">
              {t('location.title')}
            </h2>
            <p className="text-base md:text-lg text-white/70 leading-relaxed mb-10">
              {t('location.desc')}
            </p>

            <div className="space-y-5">
              {[
                { label: t('location.paris'), desc: t('location.parisDesc') },
                { label: t('location.troyes'), desc: t('location.troyesDesc') },
                { label: t('location.reims'), desc: t('location.reimsDesc') },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-4">
                  <Clock className="text-[#E92A3E] mt-0.5 flex-shrink-0" size={18} />
                  <div>
                    <p className="font-semibold text-white">{item.label}</p>
                    <p className="text-sm text-white/60">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="rounded-lg overflow-hidden h-80 lg:h-[480px]"
          >
            <iframe
              src="https://www.google.com/maps?q=5+rue+Casimir+Boirot,+51120+La+Forestiere,+France&t=m&z=13&output=embed&iwloc=near"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Red House Studio — 5 rue Casimir Boirot, La Forestière"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
